import { useEffect, useState } from "react";
import axios from "axios";
import { Clock } from "lucide-react";
import { Link } from "react-router-dom";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
const API = `${BACKEND_URL}/api`;

const formatTime = (totalSeconds) => {
  if (totalSeconds <= 0) return { d: 0, h: 0, m: 0, s: 0 };
  const d = Math.floor(totalSeconds / 86400);
  const h = Math.floor((totalSeconds % 86400) / 3600);
  const m = Math.floor((totalSeconds % 3600) / 60);
  const s = totalSeconds % 60;
  return { d, h, m, s };
};

/**
 * Banner rojo pegado en top con timer de descuento activo.
 * Se auto-refresca cada 60s desde el backend y hace tick local cada segundo.
 * Se oculta cuando expira.
 */
const PromotionBanner = () => {
  const [promo, setPromo] = useState(null);
  const [secondsLeft, setSecondsLeft] = useState(0);

  const fetchPromo = async () => {
    try {
      const { data } = await axios.get(`${API}/promotion`);
      if (data.is_live) {
        setPromo(data);
        setSecondsLeft(data.seconds_left);
      } else {
        setPromo(null);
      }
    } catch (e) {
      setPromo(null);
    }
  };

  useEffect(() => {
    fetchPromo();
    const refresh = setInterval(fetchPromo, 60000); // re-fetch cada minuto
    return () => clearInterval(refresh);
  }, []);

  useEffect(() => {
    if (!promo || secondsLeft <= 0) return;
    const tick = setInterval(() => {
      setSecondsLeft((s) => {
        if (s <= 1) {
          setPromo(null);
          return 0;
        }
        return s - 1;
      });
    }, 1000);
    return () => clearInterval(tick);
  }, [promo, secondsLeft]);

  if (!promo || secondsLeft <= 0) return null;

  const { d, h, m, s } = formatTime(secondsLeft);

  return (
    <div className="w-full bg-gradient-to-r from-[#E50914] via-red-600 to-[#E50914] text-white shadow-lg animate-pulse-slow" data-testid="promotion-banner">
      <Link to="/contaflix-pro" className="block">
        <div className="max-w-7xl mx-auto px-4 py-2 flex flex-wrap items-center justify-center gap-x-4 gap-y-1 text-center">
          <span className="font-bold text-sm sm:text-base tracking-wide uppercase">
            🔥 {promo.title || "Oferta especial"}
          </span>
          {promo.discount_percentage > 0 && (
            <span className="bg-white text-[#E50914] px-2 py-0.5 rounded font-black text-sm">
              {promo.discount_percentage}% OFF
            </span>
          )}
          {promo.description && (
            <span className="text-sm text-white/90 hidden md:inline">{promo.description}</span>
          )}
          <span className="flex items-center gap-1 text-sm font-mono font-bold" data-testid="promo-timer">
            <Clock className="w-4 h-4" />
            {d > 0 && `${d}d `}
            {String(h).padStart(2, "0")}:{String(m).padStart(2, "0")}:{String(s).padStart(2, "0")}
          </span>
          <span className="underline text-sm hidden sm:inline">Aprovechar ahora →</span>
        </div>
      </Link>
    </div>
  );
};

export default PromotionBanner;
